export function getLongDateFormat(date: Date) {
  const formatedTime = date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC"
  });
  return formatedTime;
}
